<div class="dashboard-container">
  <app-dashboard-filters (apply)="onFiltersApply($event)"></app-dashboard-filters>

  <div *ngIf="errorMessage" class="alert-error">
    {{ errorMessage }}
  </div>

  <div *ngIf="loading" class="loading-state">
    <p>Cargando datos...</p>
  </div>

  <div *ngIf="!loading" class="charts-grid" [ngClass]="'mode-' + selectedBusinessType">
    <div *ngIf="showDonutChart" class="chart-card chart-donut">
      <h3>{{ currentMode === 'categoria' ? 'CATEGORÍA' : 'ALCANCE' }}</h3>

      <div *ngIf="!hasDonutData" class="no-data">
        No hay datos para mostrar
      </div>

      <apx-chart
        *ngIf="hasDonutData && donutOptions.series"
        [series]="donutOptions.series"
        [chart]="donutOptions.chart"
        [labels]="donutOptions.labels"
        [colors]="donutOptions.colors"
        [fill]="donutOptions.fill"
        [stroke]="donutOptions.stroke"
        [plotOptions]="donutOptions.plotOptions"
        [legend]="donutOptions.legend"
        [dataLabels]="donutOptions.dataLabels"
        [tooltip]="donutOptions.tooltip">
      </apx-chart>
    </div>

    <div *ngIf="showHorizontalChart" class="chart-card chart-fuente">
      <h3>FUENTE</h3>

      <div *ngIf="!hasOfficeData" class="no-data">
        No hay datos para mostrar
      </div>

      <div class="scrollable-chart-container">
        <apx-chart
          *ngIf="hasOfficeData && horizontalOptions.series"
          [series]="horizontalOptions.series"
          [chart]="horizontalOptions.chart"
          [xaxis]="horizontalOptions.xaxis"
          [plotOptions]="horizontalOptions.plotOptions"
          [dataLabels]="horizontalOptions.dataLabels"
          [tooltip]="horizontalOptions.tooltip"
          [colors]="horizontalOptions.colors"
          [fill]="horizontalOptions.fill">
        </apx-chart>
      </div>
    </div>

    <div *ngIf="showOfficeChart" class="chart-card chart-sede">
      <h3>SEDE</h3>

      <div *ngIf="!hasOfficeData" class="no-data">
        No hay datos para mostrar
      </div>

      <div class="scrollable-chart-container">
        <apx-chart
          *ngIf="hasOfficeData && officeOptions.series"
          [series]="officeOptions.series"
          [chart]="officeOptions.chart"
          [plotOptions]="officeOptions.plotOptions"
          [xaxis]="officeOptions.xaxis"
          [dataLabels]="officeOptions.dataLabels"
          [tooltip]="officeOptions.tooltip"
          [colors]="officeOptions.colors"
          [fill]="officeOptions.fill">
        </apx-chart>
      </div>
    </div>

    <div *ngIf="showStackedChart" class="chart-card chart-empresa">
      <h3>EMPRESA</h3>

      <div *ngIf="!hasStackedData" class="no-data">
        No hay datos para mostrar
      </div>

      <apx-chart
        *ngIf="hasStackedData && stackedOptions.series"
        [series]="stackedOptions.series"
        [chart]="stackedOptions.chart"
        [xaxis]="stackedOptions.xaxis"
        [yaxis]="stackedOptions.yaxis"
        [plotOptions]="stackedOptions.plotOptions"
        [dataLabels]="stackedOptions.dataLabels"
        [legend]="stackedOptions.legend"
        [tooltip]="stackedOptions.tooltip"
        [colors]="stackedOptions.colors"
        [fill]="stackedOptions.fill">
      </apx-chart>
    </div>

    <div *ngIf="showMonthlyChart" class="chart-card chart-mes">
      <h3>tCO2e por mes</h3>

      <div *ngIf="!hasMonthlyData" class="no-data">
        No hay datos para mostrar
      </div>

      <apx-chart
        *ngIf="hasMonthlyData && monthlyOptions.series"
        [series]="monthlyOptions.series"
        [chart]="monthlyOptions.chart"
        [xaxis]="monthlyOptions.xaxis"
        [yaxis]="monthlyOptions.yaxis"
        [stroke]="monthlyOptions.stroke"
        [markers]="monthlyOptions.markers"
        [dataLabels]="monthlyOptions.dataLabels"
        [legend]="monthlyOptions.legend"
        [tooltip]="monthlyOptions.tooltip"
        [colors]="monthlyOptions.colors">
      </apx-chart>
    </div>
  </div>
</div>